import * as React from 'react';
import { Loader } from 'decentraland-ui/dist/components/Loader/Loader';
import { I18nProvider } from '../../modules/translation/utils';
export default class TranslationProvider extends React.PureComponent {
    componentDidUpdate(prevProps) {
        const { locale, onFetchTranslations } = this.props;
        if (locale && prevProps.locale !== locale) {
            onFetchTranslations(locale);
        }
    }
    renderLoading() {
        return React.createElement(Loader, { active: true, size: "massive" });
    }
    render() {
        const { children, locale, translations } = this.props;
        return translations && locale ? (React.createElement(I18nProvider, { key: locale, locale: locale, messages: translations }, children)) : (this.renderLoading());
    }
}
//# sourceMappingURL=TranslationProvider.js.map